module.exports = __webpack_public_path__ + "img/multimedi.ff520e5f.png";